module.exports = __webpack_public_path__ + "img/how_to_bcome_a_designer_sheet_button.b74d6da4.png";